import React from 'react';
import {t, endpoints, types} from 'shared/core';
import {dateSpan} from 'shared/tools'; 
import {InteractiveTable, ProgressIndicator} from 'components';
import {observer} from 'mobx-react';
import {Goal} from 'stores/performance_goals';

const GoalName = observer(({model}) => {
  return (
    <div>
      {!!model.parentGoalTitle && <div className='flex align-items-middle mb1'>
        <i className='jumbo mr1 material-icons h4'>{'arrow_forward'}</i>
        <span className='jumbo'>{model.parentGoalTitle}</span>
      </div>}
      {model.title}
    </div>
  );
});

const ProgressBar = observer(({model}) => {
  return (
    <div className='flex'>
      <div className='col-4 jumbo right-align mr1 whitespace-pre'>{model.formattedCompleteness}</div>
      <div className='col-8'>
        <ProgressIndicator items={model.progressBarItems}/>
      </div>
    </div>
  );
});

const COLUMNS = [
  {
    header: 'employees.profile.performance.goals.Name',
    width: 5,
    component: GoalName
  },
  {
    header: 'employees.profile.performance.goals.Period',
    width: 3,
    render: model => dateSpan(model.startDate, model.endDate, true)
  },
  {
    header: 'employees.profile.performance.goals.Progress',
    width: 4,
    component: ProgressBar
  }
];

const LOCALIZATION = {
  emptyState: 'employees.profile.performance.goals.No goals to display'
};

const GoalsTable = observer(({employee}) => {
  return (
    <InteractiveTable
      title={t('employees.profile.performance.goals.Goals')}
      columns={COLUMNS}
      showLinks={false}
      showPath={model => `/goals/view/${model.id}`}
      proxy={{
        type: 'async',
        endpoint: endpoints.PERFORMANCE_GOALS.GOALS_FOR_EMPLOYEE.with(employee.id),
        modelType: types.PERFORMANCE_GOALS.GOAL,
        model: Goal,
        pageSize: 5
      }}
      localization={LOCALIZATION}
    />
  );
});

export default GoalsTable;
